export default __webpack_public_path__ + "static/media/gravelafter.f1638b25.jpeg";